import React from "react";

import Backdrop from "./Backdrop";

import styled from "styled-components";

const CartModal = styled.div`
  width: 32%;
  height: 100vh;
  position: fixed;
  z-index: 7000;
  box-sizing: border-box;
  padding: 10px;

  right: calc(0%);
  background: white;
  @media (max-width: 769px) {
    width: 100%;
    left: calc(0%);
    top: 0;
    height: 100%;
  }
`;
const cart = (props) => (
  <div>
    <Backdrop clicked={props.closeModal} show={props.show} />
    <CartModal
      style={{
        transform: props.show ? "translateY(0)" : "translateY(-100vh)",
        opacity: props.show ? "1" : "0",
      }}
    >
      {props.children}
    </CartModal>
  </div>
);

export default cart;
